<ds-modal [title]="'switcher' | translate" [headerIcon]="Icons.ListUl" (modalClosed)="onClose()">
  <div>
    <form [formGroup]="form">
      <app-searchbox
        [label]="'label_search_by_name' | translate"
        class="w-100"
        role="search"
        [placeholder]="'form_search' | translate"
        [formControlName]="$userSearch.searchTerm"
      ></app-searchbox>
    </form>
  </div>

  @if (recentNavItems$ | async; as recentNavItems) {
    @if (recentNavItems.length > 0) {
      <nav  aria-labelledby="recent-digital-assets-title">
        <h3 id="recent-digital-assets-title" class="menu-title">{{ 'recent_digital_assets' | translate }}</h3>
        <ds-list-menu [menuItems]="recentNavItems" [menuAriaLabel]="'recent_digital_assets' | translate"></ds-list-menu>
      </nav>
    }
  }

  <nav  aria-labelledby="tree-nav-title">
    <h3 id="tree-nav-title" class="menu-title">{{ 'all_workspaces_and_assets' | translate }}</h3>
    <ds-tree-menu
      [menuItems]="navItems$ | async"
      [menuAriaLabel]="'all_workspaces_and_assets' | translate"
      [rootItemsAlwaysExpanded]="true"
    ></ds-tree-menu>
  </nav>
</ds-modal>
